import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { getQueryStringFromObject, ListObject } from '../../../../common';
import { API_URL } from '../../../../services/config';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { AddressEndpoint, ExportAddress } from '../constants';
import { AddressListItemBrief, AddressListSearchCriteria } from '../models';
import { AddressListStateModel } from './address-list.state';

@Injectable({
  providedIn: 'root',
})
export class AddressListService {
  constructor(private http: WrapperHttpService) {}

  getList({ size, page, ...filterView }: AddressListSearchCriteria): Observable<ListObject<AddressListItemBrief>> {
    const url = `${API_URL}${AddressEndpoint.Base}${AddressEndpoint.Page}?${getQueryStringFromObject({
      page,
      size,
    })}`;

    return this.http.withLoading().post<AddressListStateModel>(url, filterView);
  }
  /**
   *  starting export excel file
   */
  startExportToFile(
    body: { name: string; filterView: Partial<AddressListSearchCriteria> },
    addressExport: ExportAddress,
  ): Observable<void> {
    if (addressExport === ExportAddress.ExportToExcel) {
      const url = `${API_URL}${AddressEndpoint.Exports}${AddressEndpoint.Base}` + '?name=' + body.name;
      return this.http.withLoading().post<void>(url, body.filterView);
    } else {
      const url =
        `${API_URL}${AddressEndpoint.Exports}${AddressEndpoint.Base}${AddressEndpoint.Extended}` + '?name=' + body.name;
      return this.http.withLoading().post<void>(url, body.filterView);
    }
  }
}
